import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import ixOverlaysState from './state';
export const ixOverlaysSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => ixOverlaysState);
    },
    initialState: ixOverlaysState,
    name: 'ixOverlays',
    reducers: {
        errorReceiveIXOverlays: state => {
            state.ixOverlays = undefined;
            state.requestingIXOverlays = false;
        },
        failedReceiveIXOverlays: state => {
            state.ixOverlays = undefined;
            state.requestingIXOverlays = false;
        },
        receiveIXOverlays: {
            prepare: ixOverlays => {
                return {
                    payload: {
                        ixOverlays
                    }
                };
            },
            reducer: (state, action) => {
                const { ixOverlays } = action.payload;
                state.ixOverlays = ixOverlays;
                state.requestingIXOverlays = false;
            }
        },
        requestIXOverlays: {
            prepare: (consumerAPI = false) => {
                return {
                    payload: {
                        consumerAPI
                    }
                };
            },
            reducer: state => {
                state.requestingIXOverlays = true;
            }
        },
        resetIXOverlays: () => ixOverlaysState
    }
});
export const { errorReceiveIXOverlays, failedReceiveIXOverlays, receiveIXOverlays, requestIXOverlays, resetIXOverlays } = ixOverlaysSlice.actions;
export default ixOverlaysSlice.reducer;
